import React, { FC } from 'react';
import NavigationLink from 'src/shared-components/NavigationLink/NavigationLink';
import { loadingPharmacies } from 'src/utils/links';
import { generateComment } from '../utils';

const LoadingPharmacies: FC = () => {
  return (
    <div>
      <p className="mb-1">
        Необхідно регулярно присилати актуальну інформацію аптеки.
      </p>
      <p className="mb-1">
        Можна раз на добу/тиждень/місяць або при зміненні якоїсь окремої
        інформації.
      </p>
      <p className="mb-1">
        <span className="fs-body-bold">POST </span>
        <NavigationLink passClassName="underline " href={loadingPharmacies}>
          {loadingPharmacies}
        </NavigationLink>
      </p>
      <p className="mb-1">Request:</p>
      <pre>
        <code>
          <p className="indent-6">
            &#123;&quot;deleteOther&quot;: false,{' '}
            {generateComment('чи видаляти аптеки, що не прийшли у запиті')}
          </p>
          <p className="indent-6">&quot;branches&quot;: &#91;&#123;</p>
          <p className="indent-12">
            &quot;code&quot;: &quot;123456&quot;,{' '}
            {generateComment("обов'язкове, код аптеки")}
          </p>
          <p className="indent-12">
            &quot;name&quot;: &quot;Аптека №15&quot;,{' '}
            {generateComment("обов'язкове,найменування аптеки")}
          </p>
          <p className="indent-12">
            &quot;brand&quot;: &quot;Ромашка&quot;,{' '}
            {generateComment('назва аптеки на вивісці')}
          </p>
          <p className="indent-12">
            &quot;okpo&quot;: &quot;123123123&quot;,{' '}
            {generateComment("обов'язкове, необіхдне для розрахунків")}
          </p>
          <p className="indent-12">
            &quot;workTime&quot;: &quot;9:00 - 10:00&quot;,{' '}
            {generateComment("обов'язкове, час роботи аптеки")}
          </p>
          <p className="indent-12">
            &quot;latitude&quot;: &quot;49.989188&quot;,{' '}
            {generateComment("обов'язкове, широта")}
          </p>
          <p className="indent-12">
            &quot;longitude&quot;: &quot;31.23231&quot;,{' '}
            {generateComment("обов'язкове, долгота")}
          </p>
          <p className="indent-12">
            &quot;phones&quot;: [&quot;+380999352287&quot;],{' '}
            {generateComment("список номерів телефонів для зв'язку")}
          </p>
          <p className="indent-12">
            &quot;district&quot;: &quot;Харківська&quot;,{' '}
            {generateComment('область')}
          </p>
          <p className="indent-12">
            &quot;city&quot;: &quot;Дніпро&quot;,{' '}
            {generateComment("обов'язкове, місто")}
          </p>
          <p className="indent-12">
            &quot;street&quot;: &quot;Бестужева&quot;,{' '}
            {generateComment('вулиця')}
          </p>
          <p className="indent-12">
            &quot;house&quot;: &quot;26&quot;, {generateComment('номер дома')}
          </p>
          <p className="indent-12">
            &quot;enabled&quot;: true,{' '}
            {generateComment('true - аптека працює, false - не працює')}
          </p>
          <p className="indent-6">&#125;&#93;&#125;</p>
        </code>
      </pre>
    </div>
  );
};

export default LoadingPharmacies;
